export const lightTheme = {
  shopl: {
    100: '#eaf5ff',
    150: '#d6e9fb',
    200: '#84c2fc',
    300: '#3299fe',
    400: '#2d89e4',
  },
  gray: {
    BG: '#F7F9FD',
    50: '#F1F4F6',
    100: '#DCE3EE',
    200: '#CDD6E4',
    300: '#8092AA',
  },
  navy: {
    300: '#406588',
    400: '#35485b',
  },
  neutral: {
    0: '#fff',
    100: '#f9f9f9',
    150: '#f4f4f4',
    200: '#eaeaea',
    300: '#ddd',
    350: '#ccc',
    400: '#999',
    500: '#777',
    600: '#555',
    700: '#333',
  },
  green: {
    100: '#d8f2eb',
    200: '#77d5bb',
    300: '#4dc9aa',
  },
  red: {
    100: '#f9ebeb',
    200: '#ff7979',
    300: '#ff6666',
  },
  yellow: {
    100: '#fff7dd',
    200: '#ffda75',
    300: '#ffbb00',
  },
  purple: {
    100: '#eff1ff',
    300: '#6979f8',
    400: '#5C68C9',
  },
  ocean: {
    100: '#95d6d3',
    200: '#3eb0b8',
    300: '#2f839f',
  },
};

export const darkTheme = {
  shopl: {
    100: '#eaf5ff',
    150: '#d6e9fb',
    200: '#84c2fc',
    300: '#3299fe',
    400: '#2d89e4',
  },
  gray: {
    BG: '#F7F9FD',
    50: '#F1F4F6',
    100: '#DCE3EE',
    200: '#CDD6E4',
    300: '#8092AA',
  },
  navy: {
    300: '#406588',
    400: '#35485b',
  },
  neutral: {
    700: '#fff',
    600: '#f9f9f9',
    500: '#f4f4f4',
    400: '#eaeaea',
    350: '#ddd',
    300: '#ccc',
    200: '#999',
    150: '#777',
    100: '#555',
    0: '#333',
  },
  green: {
    100: '#d8f2eb',
    200: '#77d5bb',
    300: '#4dc9aa',
  },
  red: {
    100: '#f9ebeb',
    200: '#ff7979',
    300: '#ff6666',
  },
  yellow: {
    100: '#fff7dd',
    200: '#ffda75',
    300: '#ffbb00',
  },
  purple: {
    100: '#eff1ff',
    300: '#6979f8',
    400: '#5C68C9',
  },
  ocean: {
    100: '#95d6d3',
    200: '#3eb0b8',
    300: '#2f839f',
  },
};

export type ShoplChatTheme = typeof lightTheme;
